import { render } from "./ElevatorChannels.vue?vue&type=template&id=4c324502"
import script from "./ElevatorChannels.vue?vue&type=script&lang=js"
export * from "./ElevatorChannels.vue?vue&type=script&lang=js"

import "./ElevatorChannels.vue?vue&type=style&index=0&id=4c324502&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__